import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import { Grid, Button, Menu, MenuItem, Typography, Select } from '@mui/material';
import Divider from '@mui/material/Divider';
import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material';
import { MENU_ITEMS, SUB_MENU_ITEMS } from '../assets/data/dummyData';
import SubMenu from '../assets/images/SubMenu.png';

const MenuItems = () => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedValue, setSelectedValue] = useState("More");

	const open = Boolean(anchorEl);

	const theme = createTheme(); // create a theme

	// useMediaQuery hook to check if the device is in tablet mode
	const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

	// useMediaQuery hook to check if the device is in mobile mode
	const isMobileSize = useMediaQuery(theme.breakpoints.down('sm'));

	const menuItems = isTablet ? MENU_ITEMS.slice(0, 6) : MENU_ITEMS;

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelectionChange = (e) => {
		setSelectedValue(e.target.value)
	};

	return (
		<ThemeProvider theme={theme}>
			<Divider className="text-black" />
			<Box className="lg:flex">
				<CssBaseline />
				<AppBar position="static" className="">
					<Toolbar className="bg-white text-black">
						<Grid
							container
							display={"flex"}
							justifyContent="space-evenly"
							alignItems="center"
							style={{ display: isMobileSize ? "none" : { xs: "none", sm: "flex" } }}
						>
							<div className="grid grid-cols-7">
								{isTablet && menuItems.slice(0, 6).map((item) => (
									<>
										<div key={item.id}>
											<Button
												id="basic-button"
												aria-controls={open ? 'basic-menu' : undefined}
												aria-haspopup="true"
												aria-expanded={open ? 'true' : undefined}
												onClick={handleClick}
												style={{ textTransform: "none", color: "black" }}
											>
												{item.name}
											</Button>
										</div>
										<Menu
											id="basic-menu"
											anchorEl={anchorEl}
											open={open}
											onClose={handleClose}
											MenuListProps={{
												'aria-labelledby': 'basic-button',
											}}
										>
											<div className="flex">
												{SUB_MENU_ITEMS.slice(0, 3).map((title) => (
													<div key={title.id} className="px-4">
														<Typography className="pb-4" style={{ "fontWeight": "bold" }}>{title.name}</Typography>
														{title.subtitles.map((subtitle) => (
															<div>
																<Typography key={subtitle.id}>{subtitle.name}</Typography>
															</div>
														))}
													</div>
												))}
												<div className="p-4">
													<img src={SubMenu} alt="Work Place" className="object-contain" />
												</div>
											</div>
										</Menu>
									</>
								))
								}
								{isTablet &&
									<div>
										<Select
											value={selectedValue}
											onChange={handleSelectionChange}
											className="ml-2"
											renderValue={(selected) => {
												if (!selectedValue) {
													return <span>Placeholder</span>;
												}
												return selected
											}}
											placeholder="More"
											variant="standard"
										>
											{MENU_ITEMS.slice(0, 3).map((item) =>
												<MenuItem className="select-item" key={item.id} value={item.name}>{item.name}</MenuItem>
											)}
										</Select>
									</div>}
							</div>

							{!isTablet && MENU_ITEMS.map((item) => (
								<Grid item xs={1} key={item.id}>
									<div>
										<Button
											id="basic-button"
											aria-controls={open ? 'basic-menu' : undefined}
											aria-haspopup="true"
											aria-expanded={open ? 'true' : undefined}
											onClick={handleClick}
											style={{ textTransform: "none", color: "black" }}
										>{item.name}</Button>
									</div>
									<Menu
										id="basic-menu"
										anchorEl={anchorEl}
										open={open}
										onClose={handleClose}
										MenuListProps={{
											'aria-labelledby': 'basic-button',
										}}
									>
										<div className="flex">
											{SUB_MENU_ITEMS.map((title) => (
												<div key={title.id} className="px-4">
													<Typography className="pb-4" style={{ "fontWeight": "bold" }}>{title.name}</Typography>
													{title.subtitles.map((subtitle) => (
														<div className="hidden md:hidden lg:block">
															<Typography key={subtitle.id}>{subtitle.name}</Typography>
														</div>
													))}
												</div>
											))}
											<div className="p-4">
												<img src={SubMenu} alt="Work Place" className="w-full" />
											</div>
										</div>
									</Menu>
								</Grid>
							))}
						</Grid>
					</Toolbar>
				</AppBar>
			</Box>
		</ThemeProvider>
	);

};

export default MenuItems;
